import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
  loading = false,
  disabled,
  children,
  ...props
}) => {
  return (
    <Button
      disabled={loading || disabled}
      {...props}
    >
      {loading ? <CircularProgress size={24} /> : children}
    </Button>
  );
};